import { render } from "./vdvcprintcommission.vue?vue&type=template&id=d06ba470&scoped=true"
import script from "./vdvcprintcommission.vue?vue&type=script&lang=js"
export * from "./vdvcprintcommission.vue?vue&type=script&lang=js"

import "./vdvcprintcommission.vue?vue&type=style&index=0&id=d06ba470&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d06ba470"]])

export default __exports__